import React from "react";
import "./servicesvalue.css";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import slide1 from '../images/wwd-slider1.webp';
import slide2 from '../images/wwd-slider2.webp';
import slide3 from '../images/wwd-slider3.webp';
import slide4 from '../images/wwd-slider4.webp';
import { NavLink } from "react-router-dom";



  // slider data
  const sliderdata = [
    { id: 1, img: slide2, link:'managementconsultingservices',  title: 'Management Consulting', text: "Redesign repetitive processes and deploy intelligent workflows across business functions" },
    { id: 2, img: slide1, link:'investmentadvisoryservice', title: "Investment Advisory", text: "Accelerate market research, screening, diligence, portfolio monitoring, and investment decision support" },
    { id: 3, img: slide3, link:'aidataService', title: "AI & Data Solutions", text: "Build the data foundations, AI capabilities, agents, applications, and integrations required for production use" },
    { id: 4, img: slide4, link:'cfoservices', title: "CFO Services", text: "Improve reporting, forecasting, scenario analysis, exception detection, and management decision support" },
    { id: 1, img: slide2, link:'managementconsultingservices', title: 'Management Consulting', text: "Redesign repetitive processes and deploy intelligent workflows across business functions" },
    { id: 2, img: slide1, link:'investmentadvisoryservice', title: "Investment Advisory", text: "Accelerate market research, screening, diligence, portfolio monitoring, and investment decision support" },
    { id: 3, img: slide3, link:'aidataService', title: "AI & Data Solutions", text: "Build the data foundations, AI capabilities, agents, applications, and integrations required for production use" },
    { id: 4, img: slide4, link:'cfoservices', title: "CFO Services", text: "Improve reporting, forecasting, scenario analysis, exception detection, and management decision support" },
  ];



const ServicesValue = ({ data, setBlank}) => {

 const scrollToTop = () => {
    setBlank(true);
    setTimeout(() => {
    window.scrollTo(0, 0);
    }, 100);
    setTimeout(() => {
    setBlank(false);            
    }, 600);
 }

  return (
    <section className="services-value">

      <div className="services-value__container">

        {/* ==============================
            HEADING
        ============================== */}

        <div className="services-value__heading">

          <div className="services-value__accent"></div>

          <div className="services-value__heading-content">

            {data.sectionLabel && (
              <div className="services-value__label">
                {data.sectionLabel}
              </div>
            )}

            <h2>
              {data.heading.map((item, index) => (
                <React.Fragment key={index}>
                  <span
                    className={
                      item.highlight
                        ? "services-value__highlight"
                        : ""
                    }
                  >
                    {item.text}
                  </span>

                  {index < data.heading.length - 1 && <br />}
                </React.Fragment>
              ))}
            </h2>

          </div>

        </div>


        {/* ==============================
            CARDS
        ============================== */}

        {/* <div className="services-value__cards">

          {data.cards.map((card, index) => {

            const position = index - data.activeCard;

            let positionClass = "services-value__card--hidden";

            if (position === 0) {
              positionClass = "services-value__card--center";
            }

            if (position === -1) {
              positionClass = "services-value__card--left";
            }

            if (position === 1) {
              positionClass = "services-value__card--right";
            }

            return (
              <article
                key={card.id}
                className={`services-value__card ${positionClass}`}
              >

                <img
                  src={card.image}
                  alt={card.title}
                  className="services-value__image"
                />


                <div className="services-value__gradient"></div>


                <div className="services-value__card-content">

                  <h3>
                    {card.title}
                  </h3>

                  {card.description && (
                    <p>
                      {card.description}
                    </p>
                  )}

                </div>

              </article>
            );
          })}

        </div> */}

          <div className="service-value-slider">
            <Swiper
                    slidesPerView={3}
                    spaceBetween={0}
                    centeredSlides={false}
                    loop={true}
                    autoplay={{
                      delay: 3000,
                      disableOnInteraction: false,
                    }}
                    // pagination={{
                    //   clickable: false,
                    // }}
                    pagination={false}
                    navigation={true}
                    //modules={[ Pagination, Navigation]}
                    modules={[Autoplay, Pagination, Navigation]}
                    className="mySwiper"
                  >

                    {sliderdata.map((d, i) => (
                      <SwiperSlide key={i}>
                        <div className="slide-box">
                          <img src={d.img} alt="" />
                          <NavLink to={`/${d.link}`} onClick={scrollToTop}>
                          <div className="text-box">
                            <div className="heading">{d.title} </div>
                            <div className="text">{d.text} </div>
                          </div></NavLink>
                        </div>

                      </SwiperSlide>
                    ))}


                </Swiper>

          </div>

      </div>

    </section>
  );
};

export default ServicesValue;